(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_page-select"] && !Shopify.designMode) return;
  try {
    // Idempotent, delegated navigation for page-select dropdowns.
  if (!window.__dcmPageSelect) {
    window.__dcmPageSelect = true;
    document.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-page-select]');
      if (sel && sel.value) window.location.href = sel.value;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    if (!window.__dcmCountdown) {
    window.__dcmCountdown = true;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      document.querySelectorAll('[data-countdown]').forEach((el) => {
        const target = new Date(el.dataset.countdown).getTime();
        if (Number.isNaN(target)) return;
        const diff = target - Date.now();
        if (diff <= 0) {
          el.classList.add('is-expired');
          el.querySelector('.block-countdown__expired').hidden = false;
          return;
        }
        el.classList.remove('is-expired');
        const units = {
          days: Math.floor(diff / 86400000),
          hours: Math.floor(diff / 3600000) % 24,
          minutes: Math.floor(diff / 60000) % 60,
          seconds: Math.floor(diff / 1000) % 60
        };
        Object.entries(units).forEach(([unit, value]) => {
          const node = el.querySelector(`[data-unit="${unit}"]`);
          if (node) node.textContent = unit === 'days' ? String(value) : pad(value);
        });
      });
    };
    tick();
    setInterval(tick, 1000);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    // Delegated + idempotent: survives theme-editor re-renders.
  if (!window.__dcmVideoOverlay) {
    window.__dcmVideoOverlay = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-video-overlay] .block-video__play');
      if (!btn) return;
      const wrap = btn.closest('[data-video-overlay]');
      wrap.classList.add('is-playing');
      const video = wrap.querySelector('video');
      if (video) {
        video.play();
        return;
      }
      const iframe = wrap.querySelector('iframe');
      if (iframe) {
        const url = new URL(iframe.src);
        if (url.hostname.includes('youtube')) {
          url.searchParams.set('autoplay', '1');
        } else {
          url.searchParams.set('autoplay', '1');
          url.searchParams.set('muted', '0');
        }
        iframe.src = url.toString();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
